import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Loader from "./Loader";
const CustomSelectOption = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 1px 4px 1px 4px;
  font-size: ${({
  fontSize
}) => fontSize || "0.6rem"};
  border: 1px solid ${({
  borderColor
}) => borderColor || "#99B0AD"};
  border-radius: 10px;
  cursor: pointer;
  background-color: ${({
  isSelected
}) => isSelected ? "#99B0AD" : "transparent"};
  color: ${({
  isSelected
}) => isSelected ? "#FAF6E9" : "black"};
  transition: all 0.2s ease-in-out;
  margin: 1px 2px 1px 0;
  &:hover {
    border-color: rgb(163, 175, 174);
  }
`;
const CustomSelectText = styled.span`
  font-size: ${({
  fontSize
}) => fontSize || "11px"};
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
`;
const CustomSelectCheckWrapper = styled.span`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 20px;
  border: 0px solid black;
  border-radius: 50%;
  background-color: white;
  margin-left: 1px;
  position: relative;
  z-index: 0;
`;
const CustomSelectCheck = styled.span`
  position: absolute;
  z-index: 0;
  opacity: ${({
  isSelected
}) => isSelected ? 1 : 0};
  color: black;
`;
const CustomSelectContainer = styled.div`
  display: flex;
  flex-wrap: ${({
  $wrap
}) => $wrap ? "wrap" : "nowrap"};
  align-items: center;
`;
function CustomSelectArrayOfObjects({
  items,
  onSelectChange,
  selectedItems,
  wrap = false,
  fontSize = "11px" // nova prop com valor padrão
}) {
  const {
    t
  } = useTranslation();
  const handleItemClick = item => {
    if (selectedItems.includes(item)) {
      onSelectChange(selectedItems.filter(selectedItem => selectedItem !== item));
    } else {
      onSelectChange([...selectedItems, item]);
    }
  };
  return <div>
      {items ? <div>
          <CustomSelectContainer $wrap={wrap}>
            <CustomSelectOption isSelected={selectedItems.includes("tudo")} onClick={() => handleItemClick("tudo")} fontSize={fontSize}>
              <CustomSelectText fontSize={fontSize}>{t("ui.components.customSelectArrayOfObjects.tudo")}</CustomSelectText>
            </CustomSelectOption>
            {items.map((item, index) => <CustomSelectOption key={item.id} id={`custom-select-option-${index}`} isSelected={selectedItems.includes(item)} onClick={() => handleItemClick(item)} fontSize={fontSize}>
                <CustomSelectText fontSize={fontSize}>
                  {item.name === "" ? `${item.start_time} - ${item.end_time}` : item.name ? item.name : item}
                </CustomSelectText>
              </CustomSelectOption>)}
          </CustomSelectContainer>
        </div> : <Loader />}
    </div>;
}
export default CustomSelectArrayOfObjects;
